import { SVGAssets } from '@business/assets/vectors';
import { ContextMenuItem } from '@business/workflows/ComponentUI';
import { useState, useCallback } from 'react';
import { useTrashRestoreDelete } from './TrashRestoreDelete';

const contextMenuIconClassName = 'w-4 h-4 text-[#505050]';
const contextMenuIconClassNameRed = 'w-4 h-4 text-red-600';

export const useAssetFolderTrashContextMenu = () => {
  const [selectedPhotoFolder, setSelectedPhotoFolder] = useState<any>(null);
  const [isDeletePhotoFolderConfirm, setIsDeletePhotoFolderConfirm] =
    useState<boolean>(false);
  const [restorePhotoFolderId, setRestorePhotoFolderId] = useState<string>('');
  const [isPhotoFolderRestoreConfirm, setIsPhotoFolderRestoreConfirm] =
    useState<boolean>(false);

  const { deleteFolder, restoreFolder } = useTrashRestoreDelete();

  const handleDeletePhotoFolder = (
    folderId: string,
    onSuccess?: () => void,
    onError?: (error: any) => void
  ) => {
    deleteFolder({
      module: 'assets',
      folderId,
      onSuccess: () => {
        setSelectedPhotoFolder(null);
        setIsDeletePhotoFolderConfirm(false);
        onSuccess?.();
      },
      onError
    });
  };

  const handleRestorePhotoFolder = (
    folderId: string,
    onSuccess?: () => void,
    onError?: (error: any) => void
  ) => {
    restoreFolder({
      module: 'assets',
      folderId,
      onSuccess: () => {
        setRestorePhotoFolderId('');
        setIsPhotoFolderRestoreConfirm(false);
        onSuccess?.();
      },
      onError: err => {
        setIsPhotoFolderRestoreConfirm(false);
        onError?.(err);
      }
    });
  };

  const photoFolderContextMenuItems = useCallback(
    (folder: any) => [
      {
        id: '1',
        label: (
          <ContextMenuItem
            icon={
              <SVGAssets.ProfileEditIcon className={contextMenuIconClassName} />
            }
            label="Restore"
          />
        ),
        onClick: () => {
          setRestorePhotoFolderId(folder?.id);
          setIsPhotoFolderRestoreConfirm(true);
        }
      },
      {
        id: '2',
        label: (
          <ContextMenuItem
            icon={
              <SVGAssets.TrashIcon className={contextMenuIconClassNameRed} />
            }
            label="Delete"
            labelClassName="text-red-600"
          />
        ),
        onClick: () => {
          setSelectedPhotoFolder(folder?.id);
          setIsDeletePhotoFolderConfirm(true);
        }
      }
    ],
    []
  );

  return {
    photoFolderContextMenuItems,
    selectedPhotoFolder,
    setSelectedPhotoFolder,
    isDeletePhotoFolderConfirm,
    setIsDeletePhotoFolderConfirm,
    restorePhotoFolderId,
    setRestorePhotoFolderId,
    isPhotoFolderRestoreConfirm,
    setIsPhotoFolderRestoreConfirm,
    handleDeletePhotoFolder,
    handleRestorePhotoFolder
  };
};
